enum ContactType {
    Dealer = 'Dealer',
    Distributor = 'Distributor',
    MediaAgency = 'MediaAgency',
    Photographer = 'Photographer'
}

export default ContactType;